import Vue from 'vue';
interface options extends Vue {
  methods: {
    toggleAccessibility: Function
  }
}

export default Vue.extend<options>().extend({
  data() {
    return {
      accessibilityEnabled: false,
      handler: undefined
    }
  },
  methods: {
    toggleAccessibility(event: Event) {
      if (window) {
        window.dispatchEvent(window.onAccessibilityEnableEvent);
      }
    }
  },
  mounted() {
    this.handler = () => {
      this.accessibilityEnabled = !this.accessibilityEnabled;
      console.log('toggled', this.accessibilityEnabled);
    };
    if (window) {
      window.addEventListener("accessibility.toggle", this.handler);
    }
  },
  beforeDestroy() {
    if (window) {
      window.removeEventListener("accessibility.toggle", this.handler);
    }
  }
})


// WEBPACK FOOTER //
// ./src/uikit/mixins/accessibility.ts